import { useAuth } from "../contexts/AuthContext";

import AdminDashboard from "./AdminDashboard";
import CustomerDashboard from "./CustomerDashboard";

const Dashboard = () => {
  const { user } = useAuth();

  if (user?.role === "admin") {
    return <AdminDashboard />;
  }

  return <CustomerDashboard />;
};

export default Dashboard;
